import { Grid } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const NotFoundPageWrapper = styled(Grid)`
    padding-top: ${getPurpurSpacing('800')};
    padding-bottom: ${getPurpurSpacing('800')};
`;

export const NotFoundLinksList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;

    li {
        display: flex;
        align-items: center;
        gap: ${getPurpurSpacing('100')};
        margin-top: ${getPurpurSpacing('200')};
        margin-bottom: ${getPurpurSpacing('200')};
    }
`;
